import type { SxProps, Theme } from '@mui/material';

export const styles = {
    titleAndActions: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        mb: 2,
        flexWrap: 'wrap',
        gap: 1,
    } as SxProps<Theme>,
    addLocationButton: {
        '& .MuiButton-startIcon .MuiSvgIcon-root': { color: 'white' },
    } as SxProps<Theme>,
    contentContainer: (theme: Theme): SxProps<Theme> => ({
        backgroundColor: theme.palette.background.paper,
        borderRadius: '8px',
        boxShadow: theme.shadows[1],
        width: '100%',
        flex: 1,
        minHeight: 0,
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
    }),
    layoutRow: {
        display: 'flex',
        flex: 1,
        minHeight: 0,
        overflow: 'hidden',
    } as SxProps<Theme>,
    listPanel: (theme: Theme, hideOnMobile: boolean): SxProps<Theme> => ({
        flex: { xs: '1 1 auto', md: '0 0 320px' },
        width: { xs: '100%', md: 'auto' },
        height: '100%',
        overflow: 'auto',
        borderRight: { md: `1px solid ${theme.palette.grey[50]}` },
        p: 0.5,
        display: hideOnMobile ? { xs: 'none', md: 'block' } : 'block',
    }),
    detailsPanel: (hideOnMobile: boolean): SxProps<Theme> => ({
        flex: 1,
        height: '100%',
        overflow: 'auto',
        minWidth: 0,
        width: { xs: '100%', md: 'auto' },
        display: hideOnMobile ? { xs: 'none', md: 'flex' } : 'flex',
        flexDirection: 'column',
    }),
    mobileBackBar: (theme: Theme): SxProps<Theme> => ({
        display: { xs: 'flex', md: 'none' },
        alignItems: 'center',
        gap: 0.5,
        py: 1,
        px: 1.5,
        borderBottom: `1px solid ${theme.palette.grey[50]}`,
        cursor: 'pointer',
        color: theme.palette.blue.main,
        fontSize: '14px',
        fontWeight: 500,
    }),
    emptyState: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        color: 'grey.500',
        p: 4,
    } as SxProps<Theme>,
};
